// Style fragments merged on top of a component's existing styles ONLY when
// useBreakpoint() reports a mobile/tablet viewport, e.g.
//   style={isMobile ? { ...s.modal, ...sheet.panel } : s.modal}
// Never import these into a desktop code path.

export const TAP_TARGET = 44;

// Modal → full-screen sheet.
export const sheet = {
  // Applied to the fixed backdrop.
  overlay: {
    padding: 0,
    alignItems: 'stretch',
    justifyContent: 'stretch',
  },
  // Applied to the modal box itself. It becomes the scroll container so a
  // header with sheet.header can stick to the top.
  panel: {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    height: '100%',
    maxHeight: '100%',
    margin: 0,
    borderRadius: 0,
    border: 'none',
    overflowY: 'auto',
    overflowX: 'hidden',
    WebkitOverflowScrolling: 'touch',
    paddingBottom: 'env(safe-area-inset-bottom)',
    boxSizing: 'border-box',
  },
  // Applied to the modal's title row.
  header: {
    position: 'sticky',
    top: 0,
    zIndex: 5,
    background: '#fff',
    paddingTop: 'max(12px, env(safe-area-inset-top))',
  },
  // Close buttons and other icon buttons in the header.
  closeBtn: {
    minWidth: TAP_TARGET,
    minHeight: TAP_TARGET,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  // Footer action rows: keep them reachable and above the home indicator.
  footer: {
    position: 'sticky',
    bottom: 0,
    zIndex: 5,
    background: '#fff',
    paddingBottom: 'max(12px, env(safe-area-inset-bottom))',
  },
};

// Bottom-centered toast → full-width, above the iOS home indicator.
export const toastMobile = {
  left: 16,
  right: 16,
  bottom: 'calc(16px + env(safe-area-inset-bottom))',
  transform: 'none',
  textAlign: 'center',
  maxWidth: 'none',
};

// Buttons that are too small to tap.
export const tap = {
  minHeight: TAP_TARGET,
  minWidth: TAP_TARGET,
};

// Two-up KPI grid on phones.
export const kpiGridMobile = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: 10,
};

// Page container padding on phones.
export const pageMobile = {
  padding: '16px 16px calc(24px + env(safe-area-inset-bottom))',
  maxWidth: '100%',
  minWidth: 0,
  boxSizing: 'border-box',
};

// On compact viewports the page scrolls under App's sticky 56px top bar, so
// anything `position: sticky; top: …` in page content must start below it.
export const COMPACT_TOPBAR_OFFSET = 'calc(56px + env(safe-area-inset-top))';

// Short confirmations / single-control dialogs stay a small centered box on
// phones (forms with several fields use `sheet` instead).
export const dialog = {
  overlay: {
    padding: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  panel: {
    width: '100%',
    maxWidth: 400,
    maxHeight: 'calc(100% - 32px)',
    overflowY: 'auto',
    margin: 0,
    boxSizing: 'border-box',
  },
};
